// import external dependencies
import 'jquery';

// Import Font Awesome
import '@fortawesome/fontawesome-free/js/all.js';

// Import Magnific Popup
import 'magnific-popup/dist/jquery.magnific-popup';

// Import Object Fit Polyfill
import 'object-fit-polyfill/dist/object-fit-polyfill';

// Custom Event polyfill
import 'custom-event-polyfill/polyfill';

// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js